<script setup lang="ts">
  defineProps<{
    title: string;
    subtitle?: string;
  }>();
</script>

<template>
  <h2 class="text-xl font-semibold text-gray-07" data-testid="form-builder-stage-title">
    {{ title }}
  </h2>
  <p
    v-if="subtitle"
    class="mt-1 text-base text-gray-03"
    data-testid="form-builder-stage-subtitle"
  >
    {{ subtitle }}
  </p>
</template>
